import { KeyboardEvent } from 'react'

export const ParseKey = (ev: KeyboardEvent) => {
  const result = new Set()

  if (ev.altKey) { result.add('alt') }
  if (ev.ctrlKey) { result.add('ctrl') }
  if (ev.metaKey) { result.add('meta') }
  if (ev.shiftKey) { result.add('shift') }
  result.add(ev.key.toLowerCase())

  return Array.from(result).join('+').toLowerCase()
}
